module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-stock"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Stock')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Master Stock')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-warning btn-lg btn-menu",
    attrs: {
      "to": "/master_supplier_list"
    }
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Master Supplier')))])])], 1), _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-violet btn-lg btn-menu",
    attrs: {
      "to": "/master_consumable_item_list"
    }
  }, [_c('i', {
    staticClass: "fa fa-archive"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Master Consumable Item')))])])], 1), _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-teal btn-lg btn-menu",
    attrs: {
      "to": "/master_category_list"
    }
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Master Category')))])])], 1), _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-blue btn-lg btn-menu",
    attrs: {
      "to": "/master_tanomail_list"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Master Tanomail')))])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65859324!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/master-stock.pug
// module id = 862
// module chunks = 1